/* template */
<template><div class="order-head"><div :class="(!showProbability && 'less-height')" class="container"><div :class="(!showProbability && 'more-width')" class="info"><div class="title"><div class="circle-inner"><mpx-image :src="(circle)" mode="aspectFit" class="circle"/><mpx-image :src="(lightning)" mode="aspectFit" class="lightning"/></div><hl-text color="#222222" :text="(stateText.title)"/></div><mpx-view @tap="scanTip" class="sub-title"><hl-text color="#666" hlColor="#FF6400" :text="(stateText.subTitle)"><mpx-image mode="aspectFit" src="https://ut-static.udache.com/webx/sfc/XNKxsIYqRbUxR384Y6Kfa_clipboard_image_1697628299313.png" class="icon"/></hl-text></mpx-view></div><probability pageFrom="detail-page" :probability="(probabilityType)" tip="抢票成功率" v-if="(showProbability)"/></div><div class="notice-tip-content" v-if="(serviceNoticeList && serviceNoticeList.length)"><notice-tip v-for="(item, index) in (serviceNoticeList)" :key="item.index" :titleText="(item.title)" :noticeTitle="(item.noticeTitle)" type="order" @click="showNoticeTipsPop(index)" class="notice"/></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m7f64a1c2"}'>
  @keyframes turn
    0%
      transform rotate(0deg)
    100%
      transform rotate(360deg)
  .order-head
    font-weight normal
    line-height 1
    .container
      width 100%
      box-sizing border-box
      height 128px
      padding 0 10px 0 22px
      @extend .flex-center
      justify-content space-between
      &.less-height
        height 112px
      .info
        max-width calc(100% - 160px)
        &.more-width
          max-width 100%
          width 100%
      .title
        @extend .flex-center
        font-family PingFangSC-Semibold
        font-size 22px
        .circle-inner
          position relative
          display flex
          width 28px
          height 28px
          margin-right 6px
          .circle
            width 100%
            height 100%
            animation turn 1.2s linear infinite
          .lightning
            width 10px
            height 10px
            position absolute
            top 50%
            left 50%
            transform translate(-50%, -50%)
      .sub-title
        font-size 12px
        line-height 14px
        margin-top 10px
        .icon
          width 14px
          height 14px
          margin-left 1px
          display inline-block
          vertical-align middle
    .notice-tip-content
      display flex
      flex-direction column
      margin-top 10px
    .notice
      margin-top 1px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m7f64a1c2"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./scrambling-order-head.mpx.js?isComponent&outputPath=components%2Fscrambling-order-head7f64a1c2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./scrambling-order-head.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fscrambling-order-head7f64a1c2%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m7f64a1c2"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/scrambling-order-head7f64a1c2/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'notice-tip':getComponent(require("../../../material/block/notice/noticeTip.mpx?isComponent&outputPath=components%2FnoticeTip87cd944c%2Findex")),'hl-text':getComponent(require("../../../components/hl-text/index.mpx?isComponent&outputPath=components%2Findex10de904a%2Findex")),'probability':getComponent(require("../../make-order/components/probability.mpx?isComponent&outputPath=components%2Fprobability6db512d6%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
